import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosSecureInstance from "commons/axios/axiosSecureInstance";
import { RootState } from "commons/store/store";
import { downloadBlobFile } from "utils/files/downloadBlobFile";

interface EcrfDataTransferManagement {
  isLoading: boolean;
  error: any;
}

const initialState: EcrfDataTransferManagement = {
  isLoading: false,
  error: null
};

export const downloadDataTransfer = createAsyncThunk(
  "ecrfDataTransferManagement/downloadDataTransfer",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosSecureInstance.get(`/api/ecrves/${id}/data_transfer_download`, {
        responseType: 'blob',
      });

      const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];

      const now = new Date();
      const formattedDate = now.toISOString().replace(/\D/g, "").slice(0, 14);

      let fileName = `edm_${formattedDate}.xlsx`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }

      downloadBlobFile(new Blob([response.data]), fileName);

      return "File downloaded successfully";
    } catch (error: any) {
      console.error('Error exporting file:', error);
      return rejectWithValue(error.response?.data || "Failed to export file");
    }
  }
);

export const ecrfDataTransferManagementSlice = createSlice({
  name: 'ecrfDataTransferManagement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadDataTransfer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(downloadDataTransfer.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(downloadDataTransfer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const selectEcrfResourceLoading = (state: RootState) => state.ecrf.ecrfDataManagement.isLoading;

export const {} = ecrfDataTransferManagementSlice.actions;

export default ecrfDataTransferManagementSlice.reducer;
